import {
  Component,
  Renderer2,
  ViewChild,
  Input,
  AfterViewInit,
  OnDestroy,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'pbg-drawing-pad',
  templateUrl: './drawing-pad.component.html',
  styleUrls: ['./drawing-pad.component.scss']
})
export class DrawingPadComponent implements AfterViewInit, OnDestroy {
  @ViewChild('canvas')
  canvas;
  @Input()
  wordToDraw = '';
  @Output()
  savedImage: EventEmitter<any> = new EventEmitter();
  ctx;
  isDrawing = false;
  currentTool = 'pen';
  prevX = 0;
  prevY = 0;
  currX = 0;
  currY = 0;
  color = 'black';
  stroke = 5;
  height = 0;
  width = 0;
  canvasListeners = [];
  deviceType = 'mouse';

  drawEvents = {
    mouse: {
      start: 'mousedown',
      end: 'mouseup',
      move: 'mousemove',
      out: 'mouseout'
    },
    touch: {
      start: 'touchstart',
      end: 'touchend',
      move: 'touchmove',
      out: 'touchcancel'
    }
  };

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit() {
    try {
      if (document.createEvent('TouchEvent')) {
        this.deviceType = 'touch';
        console.log('Is A Touch Screen');
      }
    } catch (e) {
      // Not a touch screen.
      console.log('Is Not A Touch Screen');
    }

    const canvasWidth = window.innerWidth - 50 < 1150 ? window.innerWidth - 50 : 1150;
    this.canvas.nativeElement.setAttribute('width', canvasWidth);
    this.canvas.nativeElement.setAttribute('height', window.innerHeight - 150);

    this.ctx = this.canvas.nativeElement.getContext('2d');

    this.width = this.canvas.nativeElement.width;
    this.height = this.canvas.nativeElement.height;

    console.log('Device Type: ' + this.deviceType);

    this.canvasListeners.push(
      this.renderer.listen(
        this.canvas.nativeElement,
        this.drawEvents[this.deviceType].move,
        e => {
          this.findXY('move', e);
        }
      )
    );

    this.canvasListeners.push(
      this.renderer.listen(
        this.canvas.nativeElement,
        this.drawEvents[this.deviceType].start,
        e => {
          this.findXY('down', e);
        }
      )
    );

    this.canvasListeners.push(
      this.renderer.listen(
        this.canvas.nativeElement,
        this.drawEvents[this.deviceType].end,
        e => {
          this.findXY('up', e);
        }
      )
    );

    this.canvasListeners.push(
      this.renderer.listen(
        this.canvas.nativeElement,
        this.drawEvents[this.deviceType].out,
        e => {
          this.findXY('out', e);
        }
      )
    );
  }

  ngOnDestroy() {
    this.clean();
  }

  clean() {
    for (let i = 0; i < this.canvasListeners.length; i++) {
      this.canvasListeners[i]();
    }
  }

  setDrawingTool(tool) {
    this.currentTool = tool;

    if (tool === 'pen') {
      this.color = 'black';
      this.stroke = 5;
    } else if (tool === 'eraser') {
      this.color = 'white';
      this.stroke = 10;
    }
  }

  draw() {
    this.ctx.beginPath();
    this.ctx.lineCap = 'round';
    this.ctx.moveTo(this.prevX, this.prevY);
    this.ctx.lineTo(this.currX, this.currY);
    this.ctx.strokeStyle = this.color;
    this.ctx.lineWidth = this.stroke;
    this.ctx.stroke();
    this.ctx.closePath();
  }

  erase() {
    this.ctx.clearRect(0, 0, this.width, this.height);
    this.setDrawingTool('pen');
  }

  save() {
    const dataURL = this.getCurrentDrawing();
    this.savedImage.emit(dataURL.toString());
    this.setDrawingTool('pen');
  }

  getCurrentDrawing() {
    return this.canvas.nativeElement.toDataURL();
  }

  findXY(res, e) {
    e.preventDefault();

    let event = e;
    if (this.deviceType === 'touch') {
      event = e.targetTouches[0];
    }

    if (res === 'down') {
      this.prevX = this.currX;
      this.prevY = this.currY;
      this.currX = event.clientX - this.canvas.nativeElement.offsetLeft;
      this.currY = event.clientY - this.canvas.nativeElement.offsetTop;

      this.isDrawing = true;
      this.ctx.beginPath();
      this.ctx.fillStyle = this.color;
      this.ctx.fillRect(this.currX, this.currY, 5, 5);
      this.ctx.closePath();
    }

    if (res === 'up') {
      this.isDrawing = false;
    }

    if (res === 'move' && this.isDrawing) {
      this.prevX = this.currX;
      this.prevY = this.currY;
      this.currX = event.clientX - this.canvas.nativeElement.offsetLeft;
      this.currY = event.clientY - this.canvas.nativeElement.offsetTop;
      this.draw();
    }
  }
}
